import {Col, FloatingLabel, Form} from 'react-bootstrap'
import {defineMessages, useIntl} from 'react-intl'
import {CommercialLead} from '../leadTypes'

const cM = defineMessages({
  dba: {id: 'leads.form.commercial.dba', defaultMessage: 'DBA'},
  businessEntity: {id: 'leads.form.commercial.businessEntity', defaultMessage: 'Business entity'},
  businessClassification: {id: 'leads.form.commercial.businessClassification', defaultMessage: 'Business classification'},
  federalEin: {id: 'leads.form.commercial.federalEin', defaultMessage: 'Federal EIN'},
  businessStarted: {id: 'leads.form.commercial.businessStarted', defaultMessage: 'Business started'},
  numberEmployees: {id: 'leads.form.commercial.numberEmployees', defaultMessage: 'Number of employees'},
  annualRevenue: {id: 'leads.form.commercial.annualRevenue', defaultMessage: 'Annual revenue'},
  totalPayroll: {id: 'leads.form.commercial.totalPayroll', defaultMessage: 'Total payroll'},
  secondPhone: {id: 'leads.form.commercial.secondPhone', defaultMessage: 'Second commercial phone'},
  secondEmail: {id: 'leads.form.commercial.secondEmail', defaultMessage: 'Second commercial email'},
  contactFirstName: {id: 'leads.form.commercial.contactFirstName', defaultMessage: 'Contact first name'},
  contactMiddleName: {id: 'leads.form.commercial.contactMiddleName', defaultMessage: 'Contact middle name'},
  contactLastName: {id: 'leads.form.commercial.contactLastName', defaultMessage: 'Contact last name'},
})

export const FormComercialLead = ({info}: {info?: CommercialLead | null}) => {
  const intl = useIntl()
  return (
    <>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='dba' label={intl.formatMessage(cM.dba)}>
          <Form.Control
            name='dba'
            type='text'
            placeholder={intl.formatMessage(cM.dba)}
            defaultValue={info?.dba || undefined}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='businessEntity' label={intl.formatMessage(cM.businessEntity)}>
          <Form.Control
            name='businessEntity'
            type='text'
            placeholder={intl.formatMessage(cM.businessEntity)}
            defaultValue={info?.businessEntity || undefined}
          />
        </FloatingLabel>
      </Col>

      {/* Grupo 2 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='businessClassification' label={intl.formatMessage(cM.businessClassification)}>
          <Form.Control
            name='businessClassification'
            type='text'
            placeholder={intl.formatMessage(cM.businessClassification)}
            defaultValue={info?.businessClassification || undefined}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='federalEin' label={intl.formatMessage(cM.federalEin)}>
          <Form.Control
            name='federalEin'
            type='text'
            placeholder={intl.formatMessage(cM.federalEin)}
            defaultValue={info?.federalEin || undefined}
          />
        </FloatingLabel>
      </Col>

      {/* Grupo 3 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='businessStarted' label={intl.formatMessage(cM.businessStarted)}>
          <Form.Control
            name='businessStarted'
            type='text'
            placeholder={intl.formatMessage(cM.businessStarted)}
            defaultValue={info?.businessStarted || undefined}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='numberEmployees' label={intl.formatMessage(cM.numberEmployees)}>
          <Form.Control
            name='numberEmployees'
            type='number'
            placeholder={intl.formatMessage(cM.numberEmployees)}
            defaultValue={info?.numberEmployees || undefined}
          />
        </FloatingLabel>
      </Col>

      {/* Grupo 4 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='annualRevenue' label={intl.formatMessage(cM.annualRevenue)}>
          <Form.Control name='annualRevenue' type='text' placeholder={intl.formatMessage(cM.annualRevenue)} />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='totalPayroll' label={intl.formatMessage(cM.totalPayroll)}>
          <Form.Control
            name='totalPayroll'
            type='text'
            placeholder={intl.formatMessage(cM.totalPayroll)}
            defaultValue={info?.totalPayroll || undefined}
          />
        </FloatingLabel>
      </Col>

      {/* Grupo 5 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='secondPhone' label={intl.formatMessage(cM.secondPhone)}>
          <Form.Control
            name='secondPhone'
            type='text'
            placeholder={intl.formatMessage(cM.secondPhone)}
            defaultValue={info?.secondPhone || undefined}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='secondEmail' label={intl.formatMessage(cM.secondEmail)}>
          <Form.Control
            name='secondEmail'
            type='email'
            placeholder={intl.formatMessage(cM.secondEmail)}
            defaultValue={info?.secondEmail || undefined}
          />
        </FloatingLabel>
      </Col>

      {/* Grupo 6 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='contactFirstname' label={intl.formatMessage(cM.contactFirstName)}>
          <Form.Control
            name='contactFirstname'
            type='text'
            placeholder={intl.formatMessage(cM.contactFirstName)}
            defaultValue={info?.contactFirstname || undefined}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='contactMiddlename' label={intl.formatMessage(cM.contactMiddleName)}>
          <Form.Control
            name='contactMiddlename'
            type='text'
            placeholder={intl.formatMessage(cM.contactMiddleName)}
            defaultValue={info?.contactMiddlename || undefined}
          />
        </FloatingLabel>
      </Col>

      {/* Grupo 7 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='contactLastname' label={intl.formatMessage(cM.contactLastName)}>
          <Form.Control
            name='contactLastname'
            type='text'
            placeholder={intl.formatMessage(cM.contactLastName)}
            defaultValue={info?.contactLastname || undefined}
          />
        </FloatingLabel>
      </Col>
    </>
  )
}
